// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/modules/products/v2_0/components/UserReviews/userReviews.scss
// module id = 1408
// module chunks = 10 21